import { Theme } from "../../../../components/constants";

export default {

    prepayIconContainer: {
        position: "relative",
    },

    paynowBtnContainer: {
        textAlign: "right",
        position: "absolute",
        right: "0",
        top: "58px",
    },

    couponContainer: {
        display: "flex",
        alignItems: "end",
        columnGap: "20px"
    },

    applyButton: {
        width: "100px"
    },

    alternatePaymentOptions: {
        display: "flex",
        alignItems: "center",
        columnGap: "8px"
    },

    linkBtn: {
        color: Theme.TEXT_PRIMARY,
        fontSize: "16px",
        fontWeight: "700"
    }
}